import { render, staticRenderFns } from "./TypeAndAdmin.vue?vue&type=template&id=cefccf8e&"
import script from "./TypeAndAdmin.vue?vue&type=script&lang=ts&"
export * from "./TypeAndAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports